/**
 * These are the possible values of session.status of next
 */
enum SessionStatus {
	LOADING = 'loading',
	UNAUTHENTICATED = 'unauthenticated',
	AUTHENTICATED = 'authenticated',
}

export default SessionStatus;
